import { render, staticRenderFns } from "./ModifyBankInfo.vue?vue&type=template&id=022ce10e&scoped=true"
import script from "./ModifyBankInfo.vue?vue&type=script&lang=js"
export * from "./ModifyBankInfo.vue?vue&type=script&lang=js"
import style0 from "./ModifyBankInfo.vue?vue&type=style&index=0&id=022ce10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ce10e",
  null
  
)

export default component.exports